export default __webpack_public_path__ + "static/media/blizzard.f3fa79b8.mp3";